import VALUE from 'core/data-model/constants/values'
import { getServiceWrapper } from 'core/service-wrapper'
import { isQuickQuotePath, isFNAPath } from 'quick-quote/components/navigations/tabs'
import { PATH, ROUTE_PATH } from 'quick-quote/constants/path'
import { getToggles } from 'quick-quote/feature-toggles'

import { BasicPlanSummary } from './basic-plan-summary'
import { InvestmentBasicPlan } from './investment-basic-plan'
import { OrdinaryBasicPlan } from './ordinary-basic-plan'

const CATEGORY_ROUTE_QQ = {
  [VALUE.WHOLE_LIFE]: ROUTE_PATH.WHOLE_LIFE.INSURED_INFORMATION,
  [VALUE.HEALTH]: ROUTE_PATH.HEALTH.INSURED_INFORMATION,
  [VALUE.IHEALTHY_ULTRA]: ROUTE_PATH.IHEALTHY_ULTRA.INSURED_INFORMATION,
  [VALUE.LOAN]: ROUTE_PATH.LOAN.INSURED_INFORMATION,
  [VALUE.PROTECTION]: ROUTE_PATH.PROTECTION.INSURED_INFORMATION,
  [VALUE.SAVING]: ROUTE_PATH.SAVING.INSURED_INFORMATION,
  [VALUE.LIFE_SAVE_PRO]: ROUTE_PATH.LIFE_SAVE_PRO.INSURED_INFORMATION,
  [VALUE.FLEXI_HEALTH]: ROUTE_PATH.FLEXI_HEALTH.INSURED_INFORMATION,
  [VALUE.RETIREMENT]: ROUTE_PATH.RETIREMENT.INSURED_INFORMATION,
  [VALUE.PERFECTLIFE]: ROUTE_PATH.PERFECT_LIFE.INSURED_INFORMATION,
  [VALUE.HEALTH_TOPPING]: ROUTE_PATH.HEALTH_TOPPING.INSURED_INFORMATION,
  [VALUE.SUKHAPABDEKDEE]: ROUTE_PATH.SUKHAPABDEKDEE.INSURED_INFORMATION,
  [VALUE.LIFE_READY]: ROUTE_PATH.LIFE_READY.INSURED_INFORMATION,
  [VALUE.BUMNAN_READY]: ROUTE_PATH.BUMNAN_READY.INSURED_INFORMATION,
  [VALUE.TERM_LIFE]: ROUTE_PATH.TERM_LIFE.INSURED_INFORMATION,
  [VALUE.INDEX_LINKED]: ROUTE_PATH.INDEX_LINKED.INSURED_INFORMATION,
  [VALUE.MRTA]: ROUTE_PATH.MRTA.INSURED_INFORMATION,
  [VALUE.PA]: ROUTE_PATH.PA.INSURED_INFORMATION,
  [VALUE.S7CC]: ROUTE_PATH.S7CC.MATURITY_VALIDATE,
  [VALUE.PRODUCT_SIO]: ROUTE_PATH.PRODUCT_SIO.MATURITY_VALIDATE,
  [VALUE.PRODUCT_GIO_PREUW]: ROUTE_PATH.PRODUCT_GIO_PREUW.MATURITY_VALIDATE,
  [VALUE.LIFE_PROTECT_PLUS]: ROUTE_PATH.LIFE_PROTECT_PLUS.INSURED_INFORMATION,
}

const CATEGORY_ROUTE_QQ_FNA_PHASE = {
  [VALUE.WHOLE_LIFE]: ROUTE_PATH.WHOLE_LIFE.MARKET_CONDUCTS,
  [VALUE.HEALTH]: ROUTE_PATH.HEALTH.MARKET_CONDUCTS,
  [VALUE.IHEALTHY_ULTRA]: ROUTE_PATH.IHEALTHY_ULTRA.MARKET_CONDUCTS,
  [VALUE.LOAN]: ROUTE_PATH.LOAN.MARKET_CONDUCTS,
  [VALUE.PROTECTION]: ROUTE_PATH.PROTECTION.MARKET_CONDUCTS,
  [VALUE.SAVING]: ROUTE_PATH.SAVING.MARKET_CONDUCTS,
  [VALUE.LIFE_SAVE_PRO]: ROUTE_PATH.LIFE_SAVE_PRO.MARKET_CONDUCTS,
  [VALUE.FLEXI_HEALTH]: ROUTE_PATH.FLEXI_HEALTH.MARKET_CONDUCTS,
  [VALUE.RETIREMENT]: ROUTE_PATH.RETIREMENT.MARKET_CONDUCTS,
  [VALUE.PERFECTLIFE]: ROUTE_PATH.PERFECT_LIFE.MARKET_CONDUCTS,
  [VALUE.HEALTH_TOPPING]: ROUTE_PATH.HEALTH_TOPPING.MARKET_CONDUCTS,
  [VALUE.SUKHAPABDEKDEE]: ROUTE_PATH.SUKHAPABDEKDEE.MARKET_CONDUCTS,
  [VALUE.LIFE_READY]: ROUTE_PATH.LIFE_READY.MARKET_CONDUCTS,
  [VALUE.BUMNAN_READY]: ROUTE_PATH.BUMNAN_READY.MARKET_CONDUCTS,
  [VALUE.TERM_LIFE]: ROUTE_PATH.TERM_LIFE.MARKET_CONDUCTS,
  [VALUE.INDEX_LINKED]: ROUTE_PATH.INDEX_LINKED.MARKET_CONDUCTS,
  [VALUE.MRTA]: ROUTE_PATH.MRTA.MARKET_CONDUCTS,
  [VALUE.PA]: ROUTE_PATH.PA.MARKET_CONDUCTS,
  [VALUE.S7CC]: ROUTE_PATH.S7CC.MARKET_CONDUCTS,
  [VALUE.PRODUCT_SIO]: ROUTE_PATH.PRODUCT_SIO.MARKET_CONDUCTS,
  [VALUE.PRODUCT_GIO_PREUW]: ROUTE_PATH.PRODUCT_GIO_PREUW.MARKET_CONDUCTS,
  [VALUE.LIFE_PROTECT_PLUS]: ROUTE_PATH.LIFE_PROTECT_PLUS.MARKET_CONDUCTS,
}

const CATEGORY_ROUTE_FNA = {
  [VALUE.WHOLE_LIFE]: ROUTE_PATH.WHOLE_LIFE.MARKET_CONDUCTS,
  [VALUE.HEALTH]: ROUTE_PATH.HEALTH.MARKET_CONDUCTS,
  [VALUE.IHEALTHY_ULTRA]: ROUTE_PATH.IHEALTHY_ULTRA.MARKET_CONDUCTS,
  [VALUE.LOAN]: ROUTE_PATH.LOAN.MARKET_CONDUCTS,
  [VALUE.PROTECTION]: ROUTE_PATH.PROTECTION.MARKET_CONDUCTS,
  [VALUE.SAVING]: ROUTE_PATH.SAVING.MARKET_CONDUCTS,
  [VALUE.LIFE_SAVE_PRO]: ROUTE_PATH.LIFE_SAVE_PRO.MARKET_CONDUCTS,
  [VALUE.FLEXI_HEALTH]: ROUTE_PATH.FLEXI_HEALTH.MARKET_CONDUCTS,
  [VALUE.RETIREMENT]: ROUTE_PATH.RETIREMENT.MARKET_CONDUCTS,
  [VALUE.PERFECTLIFE]: ROUTE_PATH.PERFECT_LIFE.MARKET_CONDUCTS,
  [VALUE.HEALTH_TOPPING]: ROUTE_PATH.HEALTH_TOPPING.MARKET_CONDUCTS,
  [VALUE.SUKHAPABDEKDEE]: ROUTE_PATH.SUKHAPABDEKDEE.MARKET_CONDUCTS,
  [VALUE.LIFE_READY]: ROUTE_PATH.LIFE_READY.MARKET_CONDUCTS,
  [VALUE.BUMNAN_READY]: ROUTE_PATH.BUMNAN_READY.MARKET_CONDUCTS,
  [VALUE.TERM_LIFE]: ROUTE_PATH.TERM_LIFE.MARKET_CONDUCTS,
  [VALUE.INDEX_LINKED]: ROUTE_PATH.INDEX_LINKED.MARKET_CONDUCTS,
  [VALUE.MRTA]: ROUTE_PATH.MRTA.MARKET_CONDUCTS,
  [VALUE.PA]: ROUTE_PATH.PA.MARKET_CONDUCTS,
  [VALUE.S7CC]: ROUTE_PATH.S7CC.MARKET_CONDUCTS,
  [VALUE.PRODUCT_SIO]: ROUTE_PATH.PRODUCT_SIO.MARKET_CONDUCTS,
  [VALUE.PRODUCT_GIO_PREUW]: ROUTE_PATH.PRODUCT_GIO_PREUW.MARKET_CONDUCTS,
  [VALUE.LIFE_PROTECT_PLUS]: ROUTE_PATH.LIFE_PROTECT_PLUS.MARKET_CONDUCTS,
}

export const getLink = (productCategory, location, isOnFnaPhase, productCode) => {
  const chkProductCategory = VALUE.S7CC_PRODUCT_PLANCODE.includes(productCode) ? VALUE.S7CC : productCategory
  if (
    !CATEGORY_ROUTE_QQ[chkProductCategory] && getToggles().ENABLE_FNA_V3
      ? !CATEGORY_ROUTE_QQ[chkProductCategory]
      : !CATEGORY_ROUTE_FNA[chkProductCategory]
  )
    return
  const path = location.pathname
  const link = []

  if (isQuickQuotePath(path) && !isOnFnaPhase) {
    link.push(PATH.QUICK_QUOTE)
    link.push(CATEGORY_ROUTE_QQ[chkProductCategory])
  } else if (isQuickQuotePath(path) && isOnFnaPhase) {
    link.push(PATH.QUICK_QUOTE)
    link.push(CATEGORY_ROUTE_QQ_FNA_PHASE[chkProductCategory])
  } else if (isFNAPath(path)) {
    link.push(PATH.FNA)
    if (getToggles().ENABLE_FNA_V3) {
      link.push(CATEGORY_ROUTE_QQ[chkProductCategory])
    } else {
      link.push(CATEGORY_ROUTE_FNA[chkProductCategory])
    }
  } else {
    // Old Quick Quote
    link.push(CATEGORY_ROUTE_QQ[chkProductCategory])
  }
  return link.join('')
}

export const BasicPlanComponent = ({
  displayProduct,
  isSelected,
  cssClass,
  selectProduct,
  validateInvestmentProduct,
  validateOrdinaryProduct,
  validateNormalProduct,
  disabled,
  location,
  isOnFnaPhase,
}) => {
  const { INVESTMENT } = VALUE

  const componentProps = {
    displayProduct: displayProduct,
    isSelected: isSelected,
    cssClass: cssClass,
    selectProduct: selectProduct,
    validateNormalProduct: validateNormalProduct,
    disabled: disabled,
  }

  const serviceWrapper = getServiceWrapper()

  const linkPath = getLink(displayProduct.category, location, isOnFnaPhase, displayProduct.code)

  switch (displayProduct.category) {
    case INVESTMENT:
      return (
        <InvestmentBasicPlan
          {...componentProps}
          validateProduct={validateInvestmentProduct}
          isOnFnaPhase={isOnFnaPhase}
          location={location}
        />
      )
    default: {
      if (serviceWrapper.isOrdinaryForceLoginProduct(displayProduct)) {
        return (
          <OrdinaryBasicPlan
            {...componentProps}
            validateProduct={validateOrdinaryProduct}
            isOnFnaPhase={isOnFnaPhase}
            location={location}
            linkPath={linkPath}
          />
        )
      } else return <BasicPlan link={linkPath} {...componentProps} />
    }
  }
}

export const BasicPlan = ({
  link,
  displayProduct,
  isSelected,
  cssClass,
  selectProduct,
  validateNormalProduct,
  disabled,
}) => {
  if (!link || !displayProduct) return null
  return (
    <div
      key={displayProduct.code}
      className={['product', cssClass ? cssClass : '', isSelected ? 'selected' : '', disabled ? 'disabled' : ''].join(
        ' '
      )}
      data-product-name={displayProduct.displayName}
      data-product-code={displayProduct.code}
      onClick={() => !disabled && validateNormalProduct(displayProduct, link, isSelected)}
    >
      <div className="product-card-container">
        <BasicPlanSummary displayProduct={displayProduct} isSelected={isSelected} />
      </div>
      {/*<Link to={!disabled && link} className="product-card-container">*/}
      {/*  <BasicPlanSummary displayProduct={displayProduct} />*/}
      {/*</Link>*/}
    </div>
  )
}
